"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function forAnimationFrame() {
    return new Promise(function (resolve) {
        requestAnimationFrame(function (now) {
            resolve(now);
        });
    });
}
exports.forAnimationFrame = forAnimationFrame;
